// extracted by mini-css-extract-plugin
export default {"header-container":"SubSectionHeader_header-container__VhNi9","note":"SubSectionHeader_note__9YVNW"};